import { Component, Vue } from 'vue-property-decorator'
import CBAG1040ViewModel from './CBAG1040ViewModel'
import CBAG1020Service from '../CBAG1020/CBAG1020Service'
import { FormatConstants } from '@/common/FormatConstants'
import CommonUtil from '@/common/utils/CommonUtil'
import CommonConstants from '@/common/CommonConstants'
import { fixedContentNoLogin } from '@/assets/js/main.js'
import Numeral from 'numeral'
@Component({
  name: 'CBAG1040',
  components: {}
  })
export default class CBAG1040Controller extends Vue {
  private FormatConstants = FormatConstants
  private CommonUtil = CommonUtil
  private CommonConstants = CommonConstants
  private CBAG1020Service: CBAG1020Service = new CBAG1020Service()
  private cbag1040ViewModel: CBAG1040ViewModel = {
    notPrncpSecrTypLst: [
      {
        productName: '',
        operatCmpny: '',
        productDiv: '',
        operatMethod: '',
        feeTrustRewd: '',
        feeTrustPropertyReservesPric: '',
        descFilesUrl: '',
        operatRptUrl: '',
        trustRewdShhnFlg: '',
        productRName: '',
        pensionFundTrustProductFlag: '',
        rtnOneYear: '',
        rtnCritMon: '',
        critVal: '',
        critValBeforeDayCompre: '',
        critValCritDay: ''
      }
    ],
    prncpSecrTypLst: [
      {
        productNameFormalName: '',
        operatCmpny: '',
        productDiv: '',
        midCancelDeductExist: '',
        descFilesUrl: '',
        investPerformUrl: '',
        productRName: '',
        productCategory: '',
        appRate: '',
        appPeriodCritMon: '',
        appPeriodCritStartDay: '',
        appPeriodCritEndDay: ''
      }
    ],
    persnPlanDescPdfInfo: {
      persnPlanDescPdfName: '',
      persnPlanDescPdfUrl: ''
    },
    operatProductSelReasonPdfInfo: {
      operatProductSelReasonPdfName: '',
      operatProductSelReasonPdfUrl: ''
    },
    tabActive: 1,
    batchDispDiv: ''
  }

  /**
   * RK契約コード
   */
  private RK_CONTRACT_CODE = '9041001'

  /**
   * 画面要素描画後処理
   */
  mounted() {
    this.$nextTick(() => {
      fixedContentNoLogin()
    })
    this.init()
  }

  /**
   * 初期処理
   */
  private async init() {
    const cbaa1020ResponseModel = await this.CBAG1020Service.callAPICBAA1020(
      this.RK_CONTRACT_CODE
    )
    if (cbaa1020ResponseModel.notPrncpSecrTypLst) {
      this.cbag1040ViewModel.notPrncpSecrTypLst =
        cbaa1020ResponseModel.notPrncpSecrTypLst.map((item) => {
          if (item.feeTrustRewd) {
            const feeTrustRewd = CommonUtil.roundNumber(
              item?.feeTrustRewd,
              FormatConstants.ANNUAL_RATE_FIVE_DIGITS
            )
            item.feeTrustRewd =
              feeTrustRewd !== null
                ? feeTrustRewd.toFixed(5)
                : item.feeTrustRewd
          }
          if (item.rtnOneYear) {
            const rtnOneYear =
              item.pensionFundTrustProductFlag === '1'
                ? item.rtnOneYear
                : Numeral(item.rtnOneYear).multiply(100).value()
            item.rtnOneYear = CommonUtil.roundNumber(
              rtnOneYear,
              FormatConstants.INVEST_WITHOUT_UNIT
            )
          }
          return {
            ...item
          }
        })
    } else this.cbag1040ViewModel.notPrncpSecrTypLst = []

    if (cbaa1020ResponseModel.prncpSecrTypLst) {
      this.cbag1040ViewModel.prncpSecrTypLst =
        cbaa1020ResponseModel.prncpSecrTypLst
    } else this.cbag1040ViewModel.prncpSecrTypLst = []

    if (CommonUtil.isNotEmpty(cbaa1020ResponseModel.persnPlanDescPdfInfo)) {
      this.cbag1040ViewModel.persnPlanDescPdfInfo =
        cbaa1020ResponseModel.persnPlanDescPdfInfo
    }

    if (
      CommonUtil.isNotEmpty(cbaa1020ResponseModel.operatProductSelReasonPdfInfo)
    ) {
      this.cbag1040ViewModel.operatProductSelReasonPdfInfo =
        cbaa1020ResponseModel.operatProductSelReasonPdfInfo
    }

    this.cbag1040ViewModel.batchDispDiv = cbaa1020ResponseModel.batchDispDiv
  }

  /**
   * 元本確保型タブ切り替え
   * @param tab
   */
  private changeTab(tab) {
    this.cbag1040ViewModel.tabActive = tab
  }

  /**
   * 元本確保型_説明資料（PDF）リンク押下
   * @param pdfFilePath
   */
  private async openPDF(pdfFilePath: string) {
    window.open(pdfFilePath, '_blank')
  }

  /**
   * 戻るリンク押下
   */
  private gotoCAAG1010() {
    this.$router.push({ name: 'caag1010' })
  }

  /**
   * 第一生命のiDeCo ミライデコタブ切り替え
   */
  private gotoCBAG1020() {
    this.$router.push({ name: 'cbag1020' })
  }

  /**
   * 第一生命の個人型Vプランタブ切り替え
   */
  private gotoCBAG1030() {
    this.$router.push({ name: 'cbag1030' })
  }
}
